import React from 'react'

interface Props {}

const LandingPageParts: React.FunctionComponent<Props> = () => {
  return <>LandingPageParts</>
}

export default LandingPageParts
